import { pathSelector } from '../browser-location'
import { wordpressLanguageSelector, languagesSelector } from '../wordpress/selectors'

const getClientLanguage = () => {
    const { languages, language } = navigator
    const lang = languages && languages.length > 0 ? languages[0] : language
    return lang.substr(0, 2).toLowerCase()
}

export const pathLanguageRegexp = /\/([a-z]{2})(?=\/|$)/

export const languageSelector = createSelector(
    pathSelector,
    wordpressLanguageSelector,
    (pathname, wordpressLanguage) => {
        const pathMatch = pathname.match(pathLanguageRegexp)
        const match = pathMatch ? pathMatch[1] : getClientLanguage()

        return match ? match : wordpressLanguage
    }
)

export const pathLanguageSelector = createSelector(pathSelector, pathname => {
    const match = pathname.match(pathLanguageRegexp)

    return match && match[1]
})

export const apiLanguageCodeSelector = createSelector(languageSelector, language =>
    language ? language.toUpperCase() : null
)

export const languageObjectSelector = createSelector(
    languagesSelector,
    languageSelector,
    (languages, language) => languages[language]
)

export const localeSelector = createSelector(languageObjectSelector, language =>
    language ? language.locale.toLowerCase() : 'en'
)
